import React, { useState, useEffect } from 'react';
import { Sun, TrendingUp, Minus } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API = '/api';

const MOODS = [
  { value: 1, emoji: '\u{1F629}', label: 'Exhausted' },
  { value: 2, emoji: '\u{1F614}', label: 'Low' },
  { value: 3, emoji: '\u{1F610}', label: 'OK' },
  { value: 4, emoji: '\u{1F60A}', label: 'Good' },
  { value: 5, emoji: '\u{1F929}', label: 'Great' },
];

export function useMoodData() {
  const { authHeaders } = useAuth();
  const [moodData, setMoodData] = useState({ logged_today: false, energy: null, avg_7d: null });

  const fetchMood = async () => {
    try {
      const res = await axios.get(`${API}/symptoms/quick-mood/today`, authHeaders());
      setMoodData(res.data);
    } catch {}
  };

  useEffect(() => { fetchMood(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { moodData, refetch: fetchMood };
}

/**
 * Returns: { subtitle, subtitleColor, icon, iconColor }
 * Used by HealthCard for the Mood & Energy slot.
 */
export function getMoodCardProps(moodData, mode, expertiseLevel) {
  const isGentle = mode === 'gentle';
  const isPro = expertiseLevel === 'pro';

  if (!moodData.logged_today) {
    return {
      subtitle: isGentle ? 'No pressure' : 'Quick check-in',
      subtitleColor: '#9A9590',
    };
  }

  const selectedMood = MOODS.find(m => m.value === moodData.energy);
  const trendDir = moodData.avg_7d && moodData.energy
    ? moodData.energy > moodData.avg_7d ? 'up' : moodData.energy < moodData.avg_7d ? 'down' : 'same'
    : null;
  const showTrend = trendDir && !(isGentle && trendDir === 'down');

  let subtitleText = `Feeling ${selectedMood?.label?.toLowerCase() || 'ok'}`;
  if (isPro && moodData.avg_7d) {
    subtitleText += ` (avg ${moodData.avg_7d}/5)`;
  }

  return {
    subtitle: subtitleText,
    subtitleColor: '#9A9590',
    trend: showTrend ? trendDir : null,
    emoji: selectedMood?.emoji,
  };
}

export function MoodSubtitle({ moodData, mode, expertiseLevel }) {
  const props = getMoodCardProps(moodData, mode, expertiseLevel);
  const isGentle = mode === 'gentle';
  const trendDir = props.trend;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 3 }}>
      {props.emoji && <span style={{ fontSize: 14 }}>{props.emoji}</span>}
      <span style={{ fontSize: 12, color: props.subtitleColor, fontFamily: "'DM Sans', sans-serif" }}>
        {props.subtitle}
      </span>
      {trendDir === 'up' && <TrendingUp style={{ width: 10, height: 10, color: '#5A8C6A' }} />}
      {trendDir === 'same' && <Minus style={{ width: 10, height: 10, color: '#9A9590' }} />}
    </div>
  );
}
